import { Injectable, Injector } from '@angular/core';

import { Utilities_FrontendFlowService } from './Utilities.frontend.flow.index';


import { $frontendTypes } from './IntraOne.frontend.types'

@Injectable({ providedIn: 'root' })
export class IntraOne_FrontendFlowService {

  constructor(
    public Utilities: Utilities_FrontendFlowService,
    private injector: Injector
  ) {
  }

  public IntraOne: IntraOne_FrontendFlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
